module.exports = __webpack_public_path__ + "front/img/0.dc21e010.png";